enum AuthState {
  IsLoading,
  Authorized,
  UnAuthorized,
  UnExpected,
}

export default AuthState;
